import { Position, Toaster, Intent } from "@blueprintjs/core";
var TopToaster = Toaster.create({
  className: "top-toaster",
  position: Position.TOP
});
var BottomToaster = Toaster.create({
  className: "bottom-toaster",
  position: Position.BOTTOM
});

window.__tgClearAllToasts = function () {
  TopToaster.clear();
  BottomToaster.clear();
};

var counter = 5000;

var generateToast = function generateToast(intent) {
  return function (message, options) {
    options = options || {};
    var toastToUse = options.bottom ? BottomToaster : TopToaster;
    var updatedTimeout;

    if (options.updateTimeout) {
      //generate a slightly different than default timeout to make the update stay on the page for a full 5 seconds
      if (counter > 5500) {
        updatedTimeout = --counter;
      } else {
        updatedTimeout = ++counter;
      }
    }

    if (window.Cypress && intent === Intent.DANGER) {
      console.error("toastr error message: ", message);
    }

    var uniqKey = toastToUse.show({
      intent: intent,
      message: message,
      timeout: options.timeout || updatedTimeout,
      action: options.action,
      icon: options.icon,
      className: options.className
    }, options.key);

    function clear() {
      toastToUse.dismiss(uniqKey);
    }

    clear.key = uniqKey;
    return clear;
  };
};

function preventDuplicates(func) {
  var previousToasts = {};
  return function (message, options) {
    if (options === void 0) {
      options = {};
    }

    var clearToast = func(message, options); // no duplicate check for toasts with updates

    if (!options.key) {
      if (!options.key && previousToasts[message]) {
        previousToasts[message](); //clear it!
      }

      setTimeout(function () {
        delete previousToasts[message];
      }, options.timeout || 5000);
      previousToasts[message] = clearToast;
    }

    return clearToast;
  };
}

if (!window.toastr) window.toastr = {};

if (!window.toastr.success) {
  window.toastr.success = preventDuplicates(generateToast(Intent.SUCCESS));
}

if (!window.toastr.error) {
  window.toastr.error = preventDuplicates(generateToast(Intent.DANGER));
}

if (!window.toastr.warning) {
  window.toastr.warning = preventDuplicates(generateToast(Intent.WARNING));
}

if (!window.toastr.info) {
  window.toastr.info = preventDuplicates(generateToast(Intent.PRIMARY));
}

if (!window.toastr["default"]) {
  window.toastr["default"] = preventDuplicates(generateToast(Intent.NONE));
}